import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import moment from "moment";
import {
    createFieldDate,
    createFieldInput,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { createSearchOneCriteria } from "../request/request.logic";

const CardBorder = defineAsyncComponent(() => import("../../../../../components/card/CardBorder"));
const ReleaseResultInfoForm = defineAsyncComponent(() => import("./release-result-info/ReleaseResultInfoForm"));
const ReleaseResultProductList = defineAsyncComponent(() => import("./release-result-product/ReleaseResultProductList"));
const ReleaseOfficerList = defineAsyncComponent(() => import("./release-officer/ReleaseOfficerList"));
const InspectionRequestForm = defineAsyncComponent(() => import("../../../inspection/request/RequestForm"));

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", {
    where: [
        { openBucket: true, name: "nameTh", operator: "like", value: searchQuery },
        { logic: "OR", closeBucket: true, name: "fullCode", operator: "like", value: searchQuery },
    ],
});
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });
export const callReleaseResult = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "RELEASE_RESULT", value: searchQuery });
export const callValidateDocStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "VALIDATE_DOC_STATUS", value: searchQuery });
export const callOpenInspectionResult = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "OPEN_INSPECTION_RESULT", value: searchQuery });
export const callInspectionIncorrectResult = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INSPECTION_INCORRECT_RESULT", value: searchQuery });
export const callSequestrate = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "SEQUESTRATE", value: searchQuery });

const yesNo = [
    { id: '1', value: true, name: i18n.global.t("model.inspection.labels.isInspect") },
    { id: '2', value: false, name: i18n.global.t("model.inspection.labels.isNotInspect") }
];

export const callRelease = ({ searchQuery, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (searchQuery) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/transaction/release/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callReleaseFull = ({ props, id }) => {
    const prefix = "refRelease.";
    const criteria = {
        ...createSearchOneCriteria({ props, id, prefix }),
        where: [{ name: "refRelease.id", type: "UUID", operator: "=", value: id }],
        children: [
            {
                name: `${prefix}openInspectionsReal`,
                asName: `${prefix}openInspections`,
                select: ["**"],
                page: 0,
                size: 1,
                sort: [{ name: "createDate", type: "DESC" }],
                children: []
            },{
                name: `${prefix}officers`,
                select: ["*", "refUser.*"],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }],
                children: []
            },
            {
                name: `${prefix}refInspection.products`,
                select: ["*", "refInformProduct.id"],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }],
            },
            {
                name: `${prefix}products`,
                select: [
                    "**",
                    "refInspectionProduct.refInformProduct.**",
                ],
                page: 0,
                size: 1000000,
                sort: [{ name: "createDate", type: "ASC" }],
                children: [
                    {
                        name: "productQties",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                    },
                    {
                        name: "refInspectionProduct.productQties",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                    },
                    {
                        name: "samplingsReal",
                        asName: "samplings",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        sort: [{ name: "createDate", type: "DESC" }],
                        children: [
                            {
                                name: "distributors",
                                select: ["**"],
                                page: 0,
                                size: 1000000,
                                sort: [{ name: "createDate", type: "ASC" }],
                            },
                        ]
                    },
                    {
                        name: "sequestratesReal",
                        asName: "sequestrates",
                        select: ["**"],
                        page: 0,
                        size: 1,
                        sort: [{ name: "createDate", type: "DESC" }],
                        children: [
                            {
                                name: "addresses",
                                select: ["**"],
                                page: 0,
                                size: 1,
                                sort: [{ name: "createDate", type: "DESC" }],
                            },
                        ],
                    },
                ]
            },
        ]
    };
    return store.dispatch("resource/v1/transaction/request/search", { criteria, })
        .then(page => page.data[0])
};

export const createColumns = ({ props }) => {
    const { routerPrefix } = props;
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.release.refUserCompany"),
            dataIndex: "refReleaseTemp.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refReleaseTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refReleaseTemp?.refUserCompany?.companyNameTh
                    : record.refReleaseTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refRelease.approveCode",
            align: "center",
            dataIndexValue: ({ record }) => {
                let label = record.refRelease?.approveCode || '';
                if (record.refRelease?.refStatus?.key === "cancel") {
                    label += ` (${record.refRelease?.refStatus?.value})`
                }
                return label;
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({
            title: () => i18n.global.t("model.release.refInspection.approveCode"),
            dataIndex: "refReleaseTemp.refInspection.approveCode",
            align: "center"
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.refInspection.expireDate"),
            dataIndex: "refReleaseTemp.refInspection.expireDate",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.release.refInspection.invoiceCode"),
            dataIndex: "refReleaseTemp.products.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.refReleaseTemp?.products?.map(d => {
                    const informProduct = d.refInspectionProduct?.refInformProduct;
                    return record.refReleaseTemp?.products?.length > 1 ?
                        <div>{`(${informProduct?.invoiceSeq}) ${informProduct?.invoiceCode}`}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                        : <div>{informProduct?.invoiceCode}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                });
                return <div>{...labels}</div>
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.release.refInspection.inspectionDatetime"),
            dataIndex: "refReleaseTemp.refInspection.inspectionDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.release.refInspection.informApproveCode"),
            dataIndex: "refReleaseTemp.refInspection.refInformTemp.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
            customRender: ({ record }) => {
                if (record?.refReleaseTemp?.refInspection?.refInformTemp?.refExportCheckpoint2?.nameTh) {
                    return <div>
                        <div>- (นำผ่านเข้า) {record.refDepartment?.nameTh}</div>
                        <div>- (นำผ่านออก) {record.refReleaseTemp?.refInspection?.refInformTemp?.refExportCheckpoint2?.nameTh}</div>
                    </div>
                }
                return record.refDepartment?.nameTh;
            }
        }),
        createColumnSelect({
            visible: () => false,
            title: () => i18n.global.t("model.release.refInspection.refInformTemp.refExportCheckpoint2"),
            dataIndex: "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.id" },
            align: "center",
            sorter: false
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refInspection.refRequestDoc"),
            dataIndex: "refReleaseTemp.refInspection.refRequestDoc.value",
            inputProp: () => ({ list: ({searchQuery}) => callRequestDoc({ searchQuery }).then(d => d.filter(doc=>["02", "16", "17", "18", "19"].includes(doc?.key))), optLabel: "value" }),
            search: { name: "refReleaseTemp.refInspection.refRequestDoc.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.release.refResult"),
            dataIndex: "refReleaseTemp.refResult.value",
            inputProp: () => ({ list: callReleaseResult, optLabel: "value", }),
            search: { name: "refReleaseTemp.refResult.id" },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }).then(d => {
                    const statusKeys =
                        routerPrefix === "release-results" ?
                            ["waitApprove", "approve", "waitReleaseResult", "cancel"]
                            : ["waitApprove", "approve", "waitRelease", "cancel"];
                    return d.filter(d2 => statusKeys.includes(d2?.key));
                }),
                renderLabel: ({ item }) => {
                    const text = item?.attribute?.displayText || item?.value;
                    if (routerPrefix === "release-results") {
                        return <div>{text}</div>
                    }
                    return <div>{item?.value}</div>
                },
            }),
            customRender: ({ record }) => {
                const text = routerPrefix === "release-results" && record.refReleaseTemp?.isApproveResult ? i18n.global.t('button.approve') : record?.refStatus?.value;
                return <div>{text}</div>
            },
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { routerPrefix } = props;
    const fields = [];
    if (routerPrefix === "release-results") {
        fields.push(
            ...createFieldRequest({ props, data, key }),
            ...createFieldReleaseResult({ props, data, key }),
            ...createFieldInspection({ props, data, key }),
        )
    }
    if (["release-requests", "releases"].includes(routerPrefix)) {
        fields.push(
            ...createFieldRequest({ props, data, key }),
            ...createFieldInspection({ props, data, key }),
            ...createFieldReleaseResult({ props, data, key }),
            ...createFieldRelease({ props, data, key }),
        )
    }
    if (routerPrefix === "release-cancels") {
        fields.push(
            ...createFieldRequest({ props, data, key }),
            ...createFieldInspection({ props, data, key }),
            ...createFieldReleaseResult({ props, data, key }),
            ...createFieldRelease({ props, data, key }),
        )
    }
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly, requestTypeKeys } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => requestTypeKeys.includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRelease`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.release.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refRelease,
                            "onUpdate:value": value => {
                                const oldValue = model.refRelease;
                                model.refRelease = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneRelease({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refRelease = oldValue;
                                        }
                                    });
                                } else {
                                    cloneRelease({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRelease({ searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),

            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspection.approveCode2`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6 } }),
                label: () => i18n.global.t("model.release.refInspection.approveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refReleaseTemp?.refInspection?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspection.refRequestDoc2`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inspection.refRequestDoc"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refReleaseTemp?.refInspection?.refRequestDoc?.value,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspection.approveCode2`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 6 } }),
                label: () => i18n.global.t("model.release.refInspection.informApproveCode"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model?.refReleaseTemp?.refInspection?.refInformTemp?.approveCode,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),

            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.releaseInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forRequestRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.releaseInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.releaseInfo.remark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": value => (model.remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const createFieldRelease = ({ props, data, key }) => {
    const { viewOnly, menuContext, dataKey, request } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refDepartment.nameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.release.refDepartment")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refDepartment?.nameTh,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspection.refInformTemp.refExportCheckpoint2.nameTh`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.release.refInspection.refInformTemp.refExportCheckpoint2")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refInspection?.refInformTemp?.refExportCheckpoint2?.nameTh,
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.releaseDate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => `${i18n.global.t("model.release.releaseDate")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.releaseDate,
                            "onUpdate:value": value => (model.refReleaseTemp.releaseDate = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refValidateDocStatus`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.release.refValidateDocStatus"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refValidateDocStatus,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.refValidateDocStatus = value;
                                model.refReleaseTemp.validateDocRemark = null;
                            },
                            disabled: viewOnly,
                            list: callValidateDocStatus,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.validateDocRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.release.validateDocRemark")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.validateDocRemark,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.validateDocRemark = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refSequestrate`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.release.refSequestrate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refSequestrate,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.refSequestrate = value;
                                if (value?.key !== "1") {
                                    model.refReleaseTemp?.refInspection?.refInformTemp?.products?.forEach(d => {
                                        d.isSequestrate = false;
                                        d.setIsSequestrate?.({ modelRef, id: d.id, checked: false });
                                    });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSequestrate({ searchQuery }).then(items => items.filter(item => ["1", "3"].includes(item.key))),
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspection.isInspect`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.inspection.isInspect"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value:
                                model.refReleaseTemp?.refInspection?.isInspect === true
                                    ? yesNo.find(d => d.id === "1")
                                    : model.refReleaseTemp?.refInspection?.isInspect === false
                                    ? yesNo.find(d => d.id === "2")
                                    : undefined,
                            disabled: true,
                            list: () => yesNo,
                            optLabel: "name"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refOpenInspectionResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.release.refOpenInspectionResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refOpenInspectionResult,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.refOpenInspectionResult = value;
                                model.refReleaseTemp.refInspectionIncorrectResult = null;
                                model.refReleaseTemp.inspectionIncorrectRemark = null;
                            },
                            disabled: viewOnly,
                            list: callOpenInspectionResult,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.refInspectionIncorrectResult`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.release.refInspectionIncorrectResult"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.refInspectionIncorrectResult,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.refInspectionIncorrectResult = value;
                                model.refReleaseTemp.inspectionIncorrectRemark = null;
                            },
                            disabled: viewOnly,
                            list: callInspectionIncorrectResult,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refReleaseTemp.inspectionIncorrectRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => `${i18n.global.t("model.release.inspectionIncorrectRemark")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReleaseTemp?.inspectionIncorrectRemark,
                            "onUpdate:value": value => {
                                model.refReleaseTemp.inspectionIncorrectRemark = value;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ReleaseOfficerList`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refReleaseTemp.officers`,
                            fetchCriteria: data.officer?.fetchCriteria,
                            canCreate: viewOnly,
                            canDelete: viewOnly,
                            inspectionKey: dataKey,
                            request
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "ReleaseOfficerList" } })
                    );
                    return <ReleaseOfficerList {...componentProp}></ReleaseOfficerList>;
                }
            },
        ]
    });
};

export const createFieldReleaseResult = ({ props, data, key }) => {
    const { viewOnly, menuContext } = props;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "ReleaseResultInfo" } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}refReleaseTemp.products`,
                            fetchCriteria: data.products?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "ReleaseResultProductList" } })
                    );
                    const infoFormComponentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            dataKey: "refReleaseTemp",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "ReleaseResultInfoForm" } })
                    );

                    return <CardBorder title={i18n.global.t('views.request.releaseResultInfo.title')} class="mt-3">
                        <ReleaseResultProductList {...componentProp}></ReleaseResultProductList>
                        <CardBorder title={i18n.global.t('views.request.releaseResultInfo.result')} class="mt-5">
                            <ReleaseResultInfoForm {...infoFormComponentProp}></ReleaseResultInfoForm>
                        </CardBorder>
                    </CardBorder>
                }
            },
        ]
    });
};

export const createFieldInspection = ({ props, data }) => {
    const { routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    return putField({
        data,
        fields: [
            {
                visible: () => modelRef.refReleaseTemp?.refInspection?.refLastRequest,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const id = modelRef.refReleaseTemp?.refInspection?.refLastRequest?.id;
                    return <CardBorder title={i18n.global.t("model.inspection.title")}>
                        <InspectionRequestForm
                            id={id}
                            viewOnly={true}
                            setAppPageHeader={false}
                            visibleTabs={routerPrefix === "release-results"}
                            visibleRequestForm={false}
                        ></InspectionRequestForm>
                    </CardBorder>
                }
            },
        ]
    });
};

export const cloneRelease = ({ props, model, id }) => {
    if (id) {
        callReleaseFull({ props, id }).then(request => {
            const release = request.refRelease;
            const refReleaseTemp = copyForm({ form: { ...release, approveCode: null, isTemp: true } });
            if (id) {
                refReleaseTemp?.attachments?.forEach((d, index) => (d.refRealId = release.attachments[index].id));
                refReleaseTemp?.products?.forEach((d, index) => {
                    d.refReal = { id: release.products[index].id }
                    d.refRelease = null;
                    d.productQties?.forEach((d2, index2) => {
                        d2.refReal = { ...release.products[index].productQties[index2] };
                        d2.refReleaseProduct = null;
                    });
                    d.samplings?.forEach((d2, index2) => {
                        d2.refReal = { ...release.products[index].samplings[index2] };
                        d2.isSave = true;
                    });
                    d.sequestrates?.forEach((d2, index2) => {
                        d2.refReal = { ...release.products[index].sequestrates[index2] };
                        d2.isSave = true;
                    });
                });
                refReleaseTemp?.openInspections?.forEach((d, index) => {
                    d.refReal = { id: release.openInspections[index].id };
                    d.isSave = true;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: release?.refDepartment, refReleaseTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};